import {React, useState} from 'react';
import getBackend from 'backend/backend';
import { useTranslation } from "react-i18next";
import { Alert, Container, Form, Button } from 'react-bootstrap';
import SidebarPage from 'components/sidebar_page';
import { Paths } from 'paths';

const CreateDataIndex = () => {
    const [t] = useTranslation('common');
    const [error, setError] = useState(null);

    const [fileSystemPath, setFileSystemPath] = useState('');

    const createDataIndex = async () => {
        setError(null);

        const result = await getBackend().createDataIndex(fileSystemPath);
        if (result.error !== null) {
            setError(result.error);
        } else {
            window.location.href = Paths.DataIndex.path + '/' + result.response.id;
        }
    }

    return (
        <SidebarPage title={t('Data Index')} description={t('Data Index')}>
            {error && <Alert variant="danger">{error}</Alert>}
            <Container className="my-5">
                <h2 className="mb-4">{t('Create Data Index')}</h2>
                <Form>
                    {false &&
                        <Form.Group className="mb-3" controlId="fileSystemPath">
                            <Form.Label>{t('File System Path')}</Form.Label>
                            <Form.Control type="text" placeholder={t('Enter file system path')} value={fileSystemPath} onChange={(e) => setFileSystemPath(e.target.value)} />
                        </Form.Group>
                    }
                    <Button className="custom-button" variant="light" onClick={createDataIndex}>{t('Create')}</Button>
                </Form>
            </Container>
        </SidebarPage>
    );
};

export default CreateDataIndex;
